import React from "react";
import ThemeToggle from "./ThemeToggle";
import Logo from "./Logo";
import { Menu } from "lucide-react";

export default function MobileHeader({ onMenu }) {
  return (
    <header className="lg:hidden fixed inset-x-0 top-0 z-40
                       bg-white/80 backdrop-blur border-b border-zinc-950/5
                       dark:bg-zinc-900/80 dark:border-white/10">
      <div className="mx-auto max-w-6xl px-3 sm:px-4 h-14 flex items-center justify-between">
        <button
          type="button"
          onClick={onMenu}
          className="inline-flex w-9 h-9 items-center justify-center rounded-lg text-zinc-700 dark:text-zinc-200"
          aria-label="메뉴 열기"
        >
          <Menu size={18} />
        </button>
        <a href="/" className="font-semibold text-zinc-900 dark:text-zinc-100 text-base">
          <Logo className="h-6 w-auto text-zinc-900 dark:text-white" />
        </a>
        <ThemeToggle />
      </div>
    </header>
  );
}